function DDUMainTrack_Air({value}) {
    const getRainIntensityIcon = (v) => {
        const icon_name = v === 0 ? "wb_sunny" 
                        : v === 1 || v === 2 || v === 3 ? "rainy" 
                        : v === 4 || v === 5 ? "thunderstorm" 
                        : "wb_sunny" 

        return `${icon_name}`;
    };

    const trackStatus = {
        0: "Green",
        1: "Fast",
        2: "Opt",
        3: "Grea",
        4: "Damp",
        5: "Wet",
        6: "Flo",
    }[value["track-grip-status"]] || "Ukn";

    return (
        <div className="flex w-full flex-col gap-2 h-[20%] justify-center">
            <div className="flex w-full items-center justify-center gap-2">
                <div className="flex items-center gap-1">
                    <p className="material-symbols-outlined text-[20px]">air</p>
                    <p>{Math.round(value["road-data:air-temp"])}°</p>
                </div>

                <div className="flex items-center gap-1">
                    <p className="material-symbols-outlined text-[20px]">road</p>
                    <p>{Math.round(value["road-data:road-temp"])}°</p>
                </div>

                <div className="flex items-center justify-center bg-white px-2 py-0 rounded-[5px]"><p className="text-black font-bold text-[12px] uppercase">{trackStatus}</p></div>
            </div>

            <div className="flex w-full h-[15px]">
                <div className="flex w-[30%] border-r-[1px] items-center justify-center">
                    <p className="material-symbols-outlined text-[15px]">{getRainIntensityIcon(value["current-rain-intensity"])}</p>
                </div>

                <div className="flex w-[70%] items-center justify-center gap-2">
                    <div className="flex items-center justify-center gap-1">
                        <p>10'</p>
                        <p className="material-symbols-outlined text-[15px]">{getRainIntensityIcon(value["10-rain-intensity"])}</p>
                    </div>

                    <div className="flex items-center justify-center gap-1">
                        <p>30'</p>
                        <p className="material-symbols-outlined text-[15px]">{getRainIntensityIcon(value["30-rain-intensity"])}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DDUMainTrack_Air;